import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { plainText, richText } from '../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../modules/formatters';

export const ENABLED = 'enabled';
export const LABEL = 'label';
export const DISPLAY_LABEL = 'displayLabel';
export const CONTENT = 'content';
export const POSITION_ORDER = 'positionOrder';

const FORM_CONFIG = {
    [ENABLED]: {
        defaultValue: true,
    },
    [LABEL]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [DISPLAY_LABEL]: {
        defaultValue: true,
    },
    [CONTENT]: {
        defaultValue: '',
        validators: [richText.required, richText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
    [POSITION_ORDER]: {
        defaultValue: 0,
    },
};

export const RICH_TEXT_MODULE_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
